import React, {PropTypes,Component}  from 'react';
import './CalendarButton.less';
import tools from '../../utils/tools';
import {autobind} from 'core-decorators';
import Icon from '../Icon';

const preventEvent = (event) => {
    if (event) {
        event.preventDefault();
        event.stopImmediatePropagation && event.stopImmediatePropagation();
        event.stopPropagation();
    }
};
class CalendarButton extends Component{

  // static PropTypes = {
  //    onClick:React.PropTypes.func,
  //    dateRangeTitle:React.PropTypes.string
  // };

  constructor(props,context){
    super(props, context);
  }

  @autobind
  onClick(event){
    preventEvent(event);
    const {onClick} = this.props;
    onClick(event,this.state);
  }


  render(){
     const {dateRangeTitle='',noBorder} = this.props;
     let borderStyle = {};
     if(noBorder){
        borderStyle.border = 'none';
        borderStyle.display = 'inherit';
     }
     return (
         <div className="Calendar" style={{marginRight:"-0.2rem", color: '#999'}}>
            <div onClick={this.onClick} style= {borderStyle}>
              <span style={{color: '#666', textAlign: 'right'}}>{dateRangeTitle}</span>
              <Icon type='rili' className='rili-icon' />
            </div>
         </div>
       );
  }
}
export  default CalendarButton;
